import React from 'react';
import { noop, map, isFunction } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { dropDownActionList as DropDownActionList } from 'modules/drop-down-action-list';
 *
 * // render
 * <DropDownActionList propName='propValue'/>
 */
export const dropDownActionList = ( props ) => {
    
    return (
        <div className='ui-drop-down-action-list'>
            <div className='ui-drop-down-action-list__actions'>
                {
                    map( props.actions, ( action ) => {
                     const isActive= action.checkVisiable
                        const className= classnames( 'ui-drop-down-action-list__actions__action', 
                        {
                            
                            'ui-drop-down-action-list__actions__action--hidden': !isActive, 
                        } );
                        

                        return (
                            <div key={ action.name } className= { className } onClick={ () => {
                                props.closePopover();

                                if( action.onActionClick && isFunction( action.onActionClick ) ) {

                                    action.onActionClick();
                                } else {

                                    props.onActionClick( action );
                                }
                                   
                            } }>
                               
                                {/* icon */}
                                { isActive &&
                                <>
                                <div className='ui-drop-down-action-list__actions__action__icon'>
                                    <Icon
                                        name={ action.name === 'creditAdd' ? 'creditAdd' : action.iconName }
                                        width={ 16 }
                                        height={ 16 }
                                        fill={ action.disabled ? '#7a7a7a' : THEME.themeColorPrimary2 }
                                    />
                                </div>

                                <div className='ui-drop-down-action-list__actions__action__title'>
                                    { getLabel( action.title ) }
                                
                                </div></> }
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
dropDownActionList.displayName = 'dropDownActionList';

// set default props
dropDownActionList.defaultProps = {
    actions: [],
    onActionClick: noop,
    closeOnActionClick: true,
};

// prop types
dropDownActionList.propTypes = {};
